<!-- <app-title-bar titleText="i18n.base.login.header"></app-title-bar> -->
<div class="login-wrapper d-flex login">
  <img src="../../../assets/img/av_park_linear_green4.png" class="login_logo">
  <div class="login-border col-md-3">
    <div class="col-md-12">
      <div class="context-menu">
        <button ejs-dropdownbutton iconCss="e-icons icon-overflow-menu--vertical" [items]='dropDownButtonItems' (select)="onSelection($event)" title="select"></button>
      </div>
      <form id="loginForm" [formGroup]="loginForm" (ngSubmit)="login()" autocomplete="on">
        @if (!fA2CodeFlag) {
          <div class="form-group">
            <label for="userName">{{ "i18n.base.login.email" | translate }}</label>
            <input id="userName" name="username" type="text" autocomplete="username" class="form-control" placeholder="{{ 'i18n.base.login.email' | translate }}"
              formControlName="userName">
            <app-error-messages [control]="loginUserNameControl"></app-error-messages>
          </div>
        }
        @if (!fA2CodeFlag) {
          <div class="form-group">
            <label for="password">{{ "i18n.base.login.password" | translate }}</label>
            <app-password-input inputId="password"
                                name="password"
                                autocomplete="current-password"
                                [placeholder]="'i18n.base.login.password' | translate"
                                formControlName="password">
            </app-password-input>
            <app-error-messages [control]="loginPasswordControl"></app-error-messages>
          </div>
        }
        @if (fA2CodeFlag) {
          <div class="form-group">
            <label for="twoFactorAuthenticationToken">{{ "i18n.base.login.2fa-code" | translate }}</label>
            <input id="twoFactorAuthenticationToken" name="twoFactorAuthenticationToken" type="text" autocomplete="off" class="form-control" placeholder="{{ 'i18n.base.login.2fa-code' | translate }}"
              formControlName="twoFactorAuthenticationToken">
            <app-error-messages [control]="loginTwoFactorAuthenticationTokenControl"></app-error-messages>
          </div>
        }
        @if (!fA2CodeFlag) {
          <button type="submit" class="btn btn-primary btn-right">
            @if (loading) {
              <div class="spinner-border spinner-border-sm me-3" role="status"></div>
            }
            {{ "i18n.base.login.login" | translate }}
          </button>
        }
        @if (fA2CodeFlag) {
          <button type="submit" class="btn btn-primary btn-right">
            @if (loading) {
              <div class="spinner-border spinner-border-sm me-3" role="status"></div>
            }
            {{ "i18n.base.login.continue" | translate }}
          </button>
        }
        @if (fA2CodeFlag) {
          <a type="button" class="btn btn-secondary btn-right me-3" (click)="onBackButtonClick()">
            {{ "i18n.base.forgot-password.back-button" | translate }}
          </a>
        }
        @if (!fA2CodeFlag) {
          <a class="btn btn-link btn-right me-2" [routerLink]="[forgotPasswordRoute]">
            {{ "i18n.base.login.forgot-password" | translate }}
          </a>
        }
        @if (!fA2CodeFlag) {
          <a class="btn btn-link btn-right" [routerLink]="[registerRoute]">
            {{ "i18n.base.login.register" | translate }}
          </a>
        }
      </form>
    </div>
  </div>
</div>

